'use client';

import React, { useState } from 'react';
import Link from 'next/link';

export const TestPrepAd = () => {
  const [hoveredCard, setHoveredCard] = useState<string | null>(null);

  return (
    <section className="section" style={{ 
      padding: '4rem 0',
      background: 'var(--light-color)',
      color: 'var(--text-color)'
    }}>
      <div className="container">
        <div style={{ 
          maxWidth: '900px', 
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          {/* Header matching site patterns */}
          <div style={{ 
            textAlign: 'center', 
            marginBottom: '3rem' 
          }}>
            <div style={{
              display: 'inline-block',
              background: 'var(--card-background)',
              padding: '0.5rem 1.5rem',
              borderRadius: '8px',
              marginBottom: '1.5rem',
              fontSize: '0.85rem',
              fontWeight: '500',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              color: 'var(--text-secondary)',
              border: '1px solid var(--border-color)',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
            }}>
              Educational Partner
            </div>

            <h2 style={{ 
              fontSize: '2.25rem',
              marginBottom: '1rem',
              color: 'var(--primary-color)',
              fontWeight: '600'
            }}>
              30 Day Test Prep Partnership
            </h2>

            <p style={{ 
              color: 'var(--text-secondary)',
              fontSize: '1.1rem',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: '1.6'
            }}>
              Special discount codes for TimeLee Cares students to excel in your test preparation journey
            </p>
          </div>

          {/* Program cards matching site design */}
          <div style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem',
            marginBottom: '3rem'
          }}>
            {/* Individual Tutoring Card */}
            <div
              className="programCard"
              style={{
                background: 'var(--card-background)',
                borderRadius: '8px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                padding: '2rem',
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                transform: hoveredCard === 'individual' ? 'translateY(-5px)' : 'translateY(0)',
                border: '1px solid var(--border-color)',
                cursor: 'pointer'
              }}
              onMouseEnter={() => setHoveredCard('individual')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div style={{
                fontSize: '2.5rem',
                color: 'var(--primary-color)',
                marginBottom: '1.5rem'
              }}>
                👨‍🏫
              </div>
              
              <h3 style={{
                fontSize: '1.5rem',
                marginBottom: '1rem',
                color: 'var(--text-color)',
                fontWeight: '600'
              }}>
                Individual Tutoring
              </h3>
              
              <div style={{
                fontSize: '2.2rem',
                fontWeight: 'bold',
                color: 'var(--success-color)',
                marginBottom: '1rem'
              }}>
                20% OFF
              </div>
              
              <p style={{
                fontSize: '1rem',
                color: 'var(--text-secondary)',
                marginBottom: '1.5rem',
                lineHeight: '1.5'
              }}>
                Personalized one-on-one instruction tailored to your learning style and goals
              </p>
              
              <div style={{
                background: 'var(--light-color)',
                border: '1px solid var(--border-color)',
                padding: '1rem',
                borderRadius: '8px',
                fontFamily: 'monospace',
                fontSize: '1rem',
                fontWeight: 'bold',
                color: 'var(--primary-color)'
              }}>
                Code: TIMELEE20
              </div>
            </div>

            {/* Group Tutoring Card */}
            <div
              className="programCard"
              style={{
                background: 'var(--card-background)',
                borderRadius: '8px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                padding: '2rem',
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                transform: hoveredCard === 'group' ? 'translateY(-5px)' : 'translateY(0)',
                border: '1px solid var(--border-color)',
                cursor: 'pointer'
              }}
              onMouseEnter={() => setHoveredCard('group')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div style={{
                fontSize: '2.5rem',
                color: 'var(--primary-color)',
                marginBottom: '1.5rem'
              }}>
                👥
              </div>
              
              <h3 style={{
                fontSize: '1.5rem',
                marginBottom: '1rem',
                color: 'var(--text-color)',
                fontWeight: '600'
              }}>
                Group Tutoring
              </h3>
              
              <div style={{
                fontSize: '2.2rem',
                fontWeight: 'bold',
                color: 'var(--success-color)',
                marginBottom: '1rem'
              }}>
                10% OFF
              </div>
              
              <p style={{
                fontSize: '1rem',
                color: 'var(--text-secondary)',
                marginBottom: '1.5rem',
                lineHeight: '1.5'
              }}>
                Collaborative learning in a supportive group environment with peers
              </p>
              
              <div style={{
                background: 'var(--light-color)',
                border: '1px solid var(--border-color)',
                padding: '1rem',
                borderRadius: '8px',
                fontFamily: 'monospace',
                fontSize: '1rem',
                fontWeight: 'bold',
                color: 'var(--primary-color)'
              }}>
                Code: TIMELEE10
              </div>
            </div>
          </div>

          {/* CTA matching site button patterns */}
          <div style={{ 
            textAlign: 'center',
            marginTop: '2rem'
          }}>
            <Link
              href="https://www.30daytestprep.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--primary"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                padding: '14px 32px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '1.05rem'
              }}
              title="Visit 30 Day Test Prep website to claim your discount"
              aria-label="Get started with 30 Day Test Prep and claim your special discount code"
            >
              Visit 30 Day Test Prep
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                fill="currentColor" 
                width="18" 
                height="18"
                style={{
                  transition: 'transform 0.2s ease'
                }}
              >
                <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
              </svg>
            </Link>
            
            <p style={{
              marginTop: '1rem',
              fontSize: '0.9rem',
              color: 'var(--text-secondary)',
              fontStyle: 'italic'
            }}>
              Exclusive offer for TimeLee Cares community members
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
